import getUniqueTypes from "../../helpers/getUniqueTypes";
import isValidDataTypes from "../../helpers/isValidDataTypes";
import { PickSharePayloadData, SharePayloadData } from "../../types";

const SupportedShareDownloadFormats = ["Image", "LivePhoto", "Video"] as const;

export type ShareDownloadDataType = PickSharePayloadData<typeof SupportedShareDownloadFormats>;
export const isValidShareDownloadPayload = (
	data: SharePayloadData,
): data is ShareDownloadDataType => {
	return isValidDataTypes(SupportedShareDownloadFormats, getUniqueTypes(data));
};
